export type CameraData = { distance: number; pitch: number; yaw: number };

export type URLDataType = {
  location?: [number, number, number];
  camera?: CameraData;
  balloon?: boolean;
  /**
   * Entity type to start the island with
   * Currently, supports "student" (default) or "teacher"
   */
  entityType?: string;
  /**
   * Classroom Id for the initial island the user should connect to when starting
   */
  classId?: string;
};

export function parseURL() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const data = urlSearchParams.get("data");
  if (data) {
    try {
      const decodedData: URLDataType = JSON.parse(decodeURLString(data));
      return decodedData;
    } catch {}
  }
}

export function getNavigationTransitionSource() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const source = urlSearchParams.get("source");
  return source || "student_app";
}

export function encodeURLString(str: string) {
  // Replace base64 non-url compatible chars (base64url encoding)
  // https://www.rfc-editor.org/rfc/rfc4648#page-7
  return btoa(encodeURIComponent(str)).replace(/\+/g, "-").replace(/\//g, "_");
}

export function decodeURLString(str: string) {
  // Replace non-url compatible chars with base64 standard chars (base64url encoding)
  // https://www.rfc-editor.org/rfc/rfc4648#page-7
  return decodeURIComponent(atob(str.replace(/-/g, "+").replace(/_/g, "/")));
}
